import CallAPI from "./apiCalls";

const FIELD_MAP = {
  vendorsObj: "vendors",
  codes: "codes",
  getOrgKinds: "getOrgKinds",
  getOrgsObj: "organizations",
  getUserEmails: "emails",
  getServDesc: "getServDesc",
};

export async function loadUserValues(token, SetSharedObject) {
  const res = await CallAPI("/users/GetUsersValues", false, "get", token);
  if (res && res.status === "SUCCESS") {
    const data = res.data?.data ?? {};
    Object.entries(FIELD_MAP).forEach(([storeKey, srcKey]) => {
      if (data[srcKey] !== undefined && data[srcKey] !== null) {
        SetSharedObject(storeKey, data[srcKey]);
      }
    });
  } else {
    // The selected backend's reference data couldn't be loaded (failure/non-success).
    // Clear these lists so the UI shows empty rather than the OTHER backend's stale
    // data (e.g. AWS customers lingering after a failed switch to GCP). Empty is safer
    // and more honest than wrong-backend data.
    Object.keys(FIELD_MAP).forEach((storeKey) => SetSharedObject(storeKey, []));
  }
  return res;
}

export default loadUserValues;
